import React from "react";
import "./PricingCard.scss";
import Button from "../Button/Button";

const PricingCard = ({
  title,
  price,
  credits,
  popular,
  buttonText,
  icon: Icon,
  onClick,
  GstText,
}) => (
  <div
    className={`page-pricing-card ${popular ? "page-pricing-card--popular" : ""}`}
  >
    {popular && <div className="page-pricing-card-badge">Most Popular</div>}
    <div className="page-pricing-card-icon">
      <Icon />
    </div>
    <h3 className="page-pricing-card-title">{title}</h3>
    <div className="page-pricing-card-price">{price}</div>
    <div className="page-pricing-card-credits">{credits}</div>
    {GstText && <div className="page-pricing-card-gst">{GstText}</div>}
    <button
      className={`page-btn ${popular ? "page-btn-primary" : "page-btn-secondary"} page-pricing-card-btn`}
      onClick={onClick}
    >
      {buttonText}
    </button>
  </div>
);

export default PricingCard;
